import { Http } from "../Http";
import { SmartSearchItemDto } from "@apiModels/SmartSearch/SmartSearchItemDto.csharp";
import { SearchResult } from "../Search/SearchResult.csharp";

export interface ISearchApi {
  smartSearch(
    query: string,
    locationId?: string
  ): Promise<SmartSearchItemDto[]>;
  search(query: string, skip?: number, take?: number): Promise<SearchResult>;
}

export class SearchApi implements ISearchApi {
  public smartSearch = (
    query: string,
    locationId?: string
  ): Promise<SmartSearchItemDto[]> => {
    return Http.get(
      `/api/smart-search?query=${encodeURIComponent(query)}&locationId=${
        locationId && encodeURIComponent(locationId)
      }`,
      null
    ) as Promise<SmartSearchItemDto[]>;
  };
  public search = (
    query: string,
    skip?: number,
    take?: number
  ): Promise<SearchResult> => {
    return Http.get(
      `/api/search?query=${encodeURIComponent(query)}&skip=${
        (skip && encodeURIComponent(skip)) ?? ""
      }&take=${(take && encodeURIComponent(take)) ?? ""}`,
      null
    ) as Promise<SearchResult>;
  };
}
